import { Router } from '@angular/router';

/** Single scope (most routes). */
export const HOW_TO_SCOPE_KEY = 'howToScope';

/** Multiple scopes: merged articles in order, deduped by URL + title (Company Profile, etc.). */
export const HOW_TO_SCOPES_KEY = 'howToScopes';

/**
 * Resolves How-To scope list from the leaf route: prefers `howToScopes`, else `howToScope`, else `title`.
 */
export function getHowToScopesFromRoute(router: Router): string[] {
  let route = router.routerState.snapshot.root;
  while (route.firstChild) route = route.firstChild;

  const multi = route.data[HOW_TO_SCOPES_KEY];
  if (Array.isArray(multi) && multi.length > 0) {
    const out = [
      ...new Set(
        multi
          .map(s => String(s).trim())
          .filter(Boolean)
      )
    ];
    if (out.length > 0) return out;
  }

  const scope = route.data[HOW_TO_SCOPE_KEY] as string | undefined;
  if (scope?.trim()) return [scope.trim()];

  const title = route.data['title'] as string | undefined;
  if (title?.trim()) return [title.trim()];

  return [];
}
